import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { ProjectCard } from './ProjectList';
import { api, go, communityOpen } from './util';

/** A state's community page: its community projects (up to three), and Start a project. Hidden for other tags. */
const cache = {};
export default class TagProjects extends Component {
  view(vnode) {
    if (!communityOpen()) return null; // coming soon
    const slug = vnode.attrs.slug;
    if (!(slug in cache)) {
      cache[slug] = null;
      app.request({
        method: 'GET',
        url: api('/projects') + '?limit=3&stateSlug=' + encodeURIComponent(slug),
        errorHandler: () => {}
      }).then(r => cache[slug] = r || {
        projects: [],
        total: 0
      }).catch(() => cache[slug] = {
        projects: [],
        total: 0
      }).then(() => m.redraw());
    }
    const r = cache[slug];
    if (!r || !r.projects.length) return null;
    return m("section", {
      className: "VEvt-box VEvt-tag"
    }, m("div", {
      className: "VEvt-tagHead"
    }, m("h3", null, m("i", {
      className: "fas fa-people-carry-box",
      "aria-hidden": "true"
    }), " Community projects"), m("a", {
      href: '/projects?state=' + slug,
      onclick: go('/projects?state=' + slug)
    }, r.total > r.projects.length ? 'All ' + r.total + ' →' : 'All projects →')), m("div", {
      className: "VProj-cards"
    }, r.projects.map(p => ProjectCard(p))));
  }
}
flarum.reg.add('voucha-community', 'forum/projects/TagProjects', TagProjects);